import { render, staticRenderFns } from "./JobFieldManager.vue?vue&type=template&id=60c8a5f4&"
import script from "./JobFieldManager.vue?vue&type=script&lang=js&"
export * from "./JobFieldManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports